// Yeniden boyutlandirma geometrisi. Tutamac widget'in tepe kosesinde duruyor,
// bu yuzden buyume tutamaca dogru gitmeli; karsi kose sabit kalmali.
//   solda=false -> widget sagda, tutamac SOL-UST  -> sag + alt kenar sabit
//   solda=true  -> widget solda, tutamac SAG-UST  -> sol + alt kenar sabit
// Sag/alt cipali (CSS'teki bottom/right) widget'ta olcu degisimi kosenin
// sabit kalmasi icin yeterli; sol/ust cipali olanda sol/ust yeniden hesaplanir.
function resolveResizeBox(start, dx, dy, opts) {
    const o = opts || {};
    const clamp = (v, min, max) => Math.min(Math.max(v, min), typeof max === "number" ? max : Infinity);
    const width = clamp(o.solda ? start.width + dx : start.width - dx, o.minW || 0, o.maxW);
    const height = clamp(start.height - dy, o.minH || 0, o.maxH);
    const box = { width: width, height: height };
    if (o.topLeftAnchored) {
        box.left = o.solda ? start.left : start.left + start.width - width;
        box.top = start.top + start.height - height;
    }
    return box;
}

// Olcek donusumu kutuyu alt koseden buyutuyor (sagda: sag-alt, solda: sol-alt);
// gorunen kutu yerlesim kutusundan o kadar yukari/yana tasiyor. Sol-ust cipali
// kutunun gorunen hali ekranda kalsin diye left/top buna gore sinirlanir.
function fitTopLeft(pos, size, opts) {
    const o = opts || {};
    const s = o.scale > 0 ? o.scale : 1;
    const clamp = (v, min, max) => Math.max(Math.min(v, max), min);
    const minLeft = o.solda ? 0 : size.width * (s - 1);
    const maxLeft = o.solda ? o.vw - size.width * s : o.vw - size.width;
    return {
        left: clamp(pos.left, minLeft, maxLeft),
        top: clamp(pos.top, size.height * (s - 1), o.vh - size.height),
    };
}

module.exports = { resolveResizeBox, fitTopLeft };



//////////////////
// WEBPACK FOOTER
// ./static/src/widgetLayout.js
// module id = xIkd
// module chunks = 1